// extracted by mini-css-extract-plugin
export default {"container":"s3-video-upload_container__YA7B3","shimmer":"s3-video-upload_shimmer__0rHM5"};